import { useLingui } from "@lingui/react/macro";
import { useCappedList } from "./useCappedList";

type Subscriber = {
  id: number;
  full_name?: string;
  email: string;
};

export const useFormatSubscribers = () => {
  const { t } = useLingui();
  const formatCappedList = useCappedList();

  return <T extends Subscriber>(
    subscribers: T[] | undefined,
    currentUserId: number
  ) => {
    if (!subscribers) return "-";

    return formatCappedList([
      ...new Set(
        subscribers
          .toSorted((a, b) => {
            if (a.id === currentUserId) return -1;
            if (b.id === currentUserId) return 1;
            return (a.full_name || a.email).localeCompare(
              b.full_name || b.email
            );
          })
          .map((sub) =>
            sub.id === currentUserId ? t`Du` : sub.full_name || sub.email
          )
      ),
    ]);
  };
};
